import {gql} from '@apollo/client';
import {PopDisqualifyReasonOption} from '../types/PopReviewType';

/**
 * 不合格原因字典（按 displayOrder 升序），按入审场景各一套
 * 文案单一来源为服务端三语，前端按 locale 取 texts 对应 entry.text，改文案无需发前端版本。
 */
export const GET_POP_DISQUALIFY_REASON_LIST = gql`
    query GetPopDisqualifyReasonList($reviewScene: String) {
        getPopDisqualifyReasonList(reviewScene: $reviewScene) {
            code
            displayOrder
            texts {
                lang
                text
            }
            categoryCode
            categoryTexts {
                lang
                text
            }
        }
    }
`;

export interface GetPopDisqualifyReasonListResponse {
    getPopDisqualifyReasonList: PopDisqualifyReasonOption[];
}
